import { Volume2 } from "lucide-react";
import { t } from "@/i18n";

/* Prononciation via l'API navigateur SpeechSynthesis — pas de backend, pas
   de coût, fonctionne hors-ligne sur la plupart des navigateurs. */
function speakArabic(text) {
  if (!text || typeof window === "undefined" || !window.speechSynthesis) return;
  window.speechSynthesis.cancel(); // interrompt une lecture en cours
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = "ar-SA";
  utter.rate = 0.85;
  window.speechSynthesis.speak(utter);
}

/* Fiche d'un mot — mot arabe, translittération, traduction et racine.
   Même composant utilisé partout : écran de découverte (VocabQuizSession,
   Daily Plan) et fiche d'indice pendant le quiz. */
export default function WordCard({ word }) {
  if (!word) return null;
  return (
    <div className="text-center">
      <div className="flex items-center justify-center gap-2 mb-1">
        <div className="arabic text-4xl sm:text-5xl leading-snug" dir="rtl">
          {word.word_ar}
        </div>
        <button
          type="button"
          onClick={() => speakArabic(word.word_ar)}
          aria-label={t("wordcard.ecouter_la_prononciation")}
          className="shrink-0 w-9 h-9 rounded-full border grid place-items-center hover:bg-secondary transition"
        >
          <Volume2 size={16} />
        </button>
      </div>
      {word.word_latin && (
        <div className="text-sm text-muted-foreground mb-3">
          {word.word_latin}
        </div>
      )}
      <div className="grid grid-cols-2 gap-2 text-left">
        <div className="rounded-xl bg-secondary/50 p-2.5 sm:p-3">
          <div className="text-[10px] uppercase font-bold text-muted-foreground">
            {t("wordcard.traduction")}
          </div>
          <div className="font-semibold text-sm sm:text-base">
            {word.translation_en || "—"}
          </div>
        </div>
        <div className="rounded-xl bg-secondary/50 p-2.5 sm:p-3">
          <div className="text-[10px] uppercase font-bold text-muted-foreground">
            {t("wordcard.racine")}
          </div>
          <div className="font-semibold text-sm sm:text-base" dir="rtl">
            {word.root || "—"}
          </div>
        </div>
      </div>
    </div>
  );
}
